import { useState, useEffect, useContext, useCallback  } from 'react';
import axios from 'axios';

import { Box, Chip, CircularProgress, Divider,
     Paper, Stack, Tooltip} from  '@mui/material';



import {ccColorSecondaryAzure, ccColorSecondaryBronze, ccColorSecondaryGreen, ccColorSecondaryPink, ccColorSecondaryPurple, lionProductColors} from '../components/helpersStyles';

import { Icon as Iconify } from '@iconify/react';

import CountUp from 'react-countup';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import utc from 'dayjs/plugin/utc';

import {lionObjectsColors}  from '../components/helpersStyles';
import './reportDashboard.css'


dayjs.extend(utc);

const StatsTile = (props) => {
    const [showProgress, setShowProgress] = useState(true);
    const [theNumber, setTheNumber] = useState(0);

    useEffect(() => {
        //new Intl.NumberFormat().format(theNumber)
        if (props.value === undefined) setShowProgress(true);
        else {
            setShowProgress(false)
            setTheNumber(props.value)
        }
    }, [props.value])


    return <div style={{backgroundColor: props.color}} className='h-36 px-6 py-5 w-full font-poppins flex flex-col' >
        <div className=' text-white'>{props.title}</div>
        {showProgress && <div className='flex flex-row justify-center mt-4 text-white'> <CircularProgress size={32} color='inherit'  /></div>}

        {!showProgress && <>
        <div className=' text-white font-bold text-3xl'>{!isNaN(Number(theNumber)) ? <CountUp end={theNumber} /> : theNumber}</div>
        {props.footer && <><div className='flex grow'> </div>
                            <div className='text-sm text-white '>
                            {props.footer}
                            </div>
                    
                    </>
        }
        {/* 
        <div className='flex flex-row justify-end w-full'>
            <div style={{color: props.color}} className=' bg-white/70 rounded-sm font-semibold py-1 px-2 text-xs'>+9%</div>
        </div>
        <div className='flex flex-row justify-end w-full'>
            <div className=' text-white py-1  text-[10px]'>compared to last week</div>
        </div>
        */}
        </>
        }
    </div>
}
export const ReportBar = (props) => {
    const [stats, setStats] = useState([])

    useEffect(() => {
        setStats([])

    }, [props.stats])

        

    return <div className='flex flex-row gap-x-0'>
        {props.stats && <>
            {props.stats[0] && <div className='w-1/5'>
                <StatsTile color={ccColorSecondaryPink} title={props.stats[0].title}
                value={props.stats[0].value}
                footer={props.stats[0].footer}
                />
                </div>
            }
            {props.stats[1] && <div className='w-1/5'>
                <StatsTile color={ccColorSecondaryGreen} title={props.stats[1].title}
                value={props.stats[1].value}
                footer={props.stats[1].footer}
                />
                </div>
            }
            {props.stats[2] && <div className='w-1/5'>
                <StatsTile color={ccColorSecondaryPurple} title={props.stats[2].title}
                value={props.stats[2].value}
                footer={props.stats[2].footer}
                />
                </div>
            }
            {props.stats[3] && <div className='w-1/5'>
                <StatsTile color={ccColorSecondaryAzure} title={props.stats[3].title}
                value={props.stats[3].value}
                footer={props.stats[3].footer}
                />
                </div>
            }
            {props.stats[4] && <div className='w-1/5'>
                <StatsTile color={ccColorSecondaryBronze} title={props.stats[4].title}
                value={props.stats[4].value}
                footer={props.stats[4].footer}
                />
                </div>
            }

        </>
        }

    </div>
}

